<template>
  <IconListItem icon="prize" :label="$t('common.words.price')">
    <slot>
      {{ formatMoney(price) }}
    </slot>
  </IconListItem>
</template>

<script lang="ts" setup>
import type { Money } from '#api/shared/@types/generated/backend/graphql-schema-types'

export type IconListItemDateProps = {
  price: Money
}

defineProps<IconListItemDateProps>()
</script>
